import React, { useReducer, useEffect, useContext } from "react"
import { SessionService } from "../services/SessionService";
import { HullApi } from "../api/hull.api";
import { Action } from "../models/Action";
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import StorageService from "../services/StorageService";
import { awaitWithLoading } from "../services/utils";
import { PaymentMethod } from "../models/user-models/CreditCardModal";
import {ModificationApi} from "../api/modification.api"
import { PolicyManagementContextStore } from "./PolicyManagementContext";
import { useParams } from "react-router-dom";
import { InsuranceStatus } from '../models/insurance-models/InsuranceStatus';
import { SessionContextStore } from "./SessionContext";


export const POLICY_MODIFICATION_CONTEXT_ACTIONS = {
    LOAD_LIABILITY_OPTIONS: 'LOAD_LIABILITY_OPTIONS',
    EDIT_DRONE: 'EDIT_DRONE',
    EDIT_EQUIPMENT: 'EDIT_EQUIPMENT',

    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD',
    SET_EXTERNAL_USER_ID: 'SET_EXTERNAL_USER_ID' ,
    SET_IS_LIABILITY_VALID: 'SET_LIABILITY_VALID',
    SET_IS_NUMBER_OF_DRONES_VALID: 'SET_IS_NUMBER_OF_DRONES_VALID',
    SET_IS_HULL_SECTION_VALID: 'SET_IS_HULL_SECTION_VALID',
    SET_IS_ADDIONTAL_COVERAGE_VALID: 'SET_IS_ADDIONTAL_COVERAGE_VALID'
}

export const ONGOING_PURCHASE = 'purchase_ongoing';


const defaultSubscriptioInsurance = {
    insuranceChanged:false,
    insuranceId: "",
    liabilityLimitOptions:[],
    liabilityLimit: 0,
    medicalExpenseLimit: 0,
    numberOfDronesOperate:0,
    personalInjuryLimit: 0,
    liabilityLimitPremium:0,
    price: 0,
    commercial: false,
    priceWithTaxes: 1,
    totalDiscount: 1,
    dronePremium: 1,
    equipmentPremium: 1,
    billingPeriod: "Year",
    medicalExpenseLimitPremium: 0,
    personalInjuryLimitpremium: 0,
    equipment: [],
    drones: [],
    namedInsured: null,
    additionalInsuredList:[],
    stripeCustomerId: null
} 


const defaultState = {
    isEditNamedInsured: false,
    insuranceId:"",
    insurance:  defaultSubscriptioInsurance,
    subscription:  defaultSubscriptioInsurance,
    externalUserId: '',
    nextPolicyDate: new Date(),
    additionalInsuredList: [],
    autoRenew: true, 
    equipmentTypes: [],
    paymentMethod: PaymentMethod.STRIPE,
    allAdditionalInsuredList: [],
    isLiabilityValid: true,
    isNumberOfDronesValid: true,
    isHullSectionValid: true,
    isAddionalCoverageValid: true,
    setMedicalExpenseLimit: (option, isRenewal) => { "Not Implemented"},
    setNumberOfDronesOperate: (option, isRenewal) => { "Not Implemented"},
    setLiabilityLimit: (option,isRenewal) => { "Not Implemented"},
    setPersonalInjuryLimit: (option, isRenewal) => { "Not Implemented"},
    addDrone: (drone,index,isRenewal) => {"Not Implemented"},
    addEquipment: (equipment,index,isRenewal) => {"Not Implemented"},
    editDrone: (drone, index,isRenewal) => {"Not Implemented"},
    editEquipment: (equipment, index, isRenewal) => {"Not Implemented"},
    dispatch: (action: Action) => {"Not Implemented"},
    deleteItem: (item => {"Not Implemented"}),
}

const reducer = (state, action: Action) => {
    
    const newStateCalculate = () => {
        switch (action.type) {
            case 'RESET':
                return {...state, drones: [], equipment: [], autoRenew: true, additionalInsuredList: []}
            case 'SET_SUBSCRIPTION_DATA':
                return {...state ,subscription:action.data}
            case 'SET_INSURANCE_DATA':
                return {...state ,insurance:action.data}
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.LOAD_LIABILITY_OPTIONS:
                return {...state, liabilityLimitOptions: action.data}
            case 'SET_COMMERCIAL_SUBSCRIPTION':
                return {...state, subscription: {...state.subscription, commercial: action.data}}
            case 'SET_COMMERCIAL_INSURANCE':
                return {...state, insurance: {...state.insurance, commercial: action.data}}
            case 'CHANGE_MEDICAL_EXPENSE_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, medicalExpenseLimit: action.data }}
            case 'CHANGE_MEDICAL_EXPENSE_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, medicalExpenseLimit: action.data }}
            case 'CHANGE_LIABILIY_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, liabilityLimit: action.data}}
            case 'CHANGE_LIABILIY_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, liabilityLimit: action.data}}
            case 'CHANGE_PERSONAL_INJURY_LIMIT_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, personalInjuryLimit: action.data}}
            case 'CHANGE_PERSONAL_INJURY_LIMIT_INSURANCE':
                return {...state , insurance: {...state.insurance,insuranceChanged:true, personalInjuryLimit: action.data}}
            case 'CHANGE_NUMBER_OF_DRONES_OPERATE_SUBSCRIPTION':
                return {...state , subscription: {...state.subscription, numberOfDronesOperate: action.data}}
            case 'CHANGE_NUMBER_OF_DRONES_OPERATE_INSURANCE':
                return {...state , insurance: {...state.insurance, numberOfDronesOperate: action.data}}
            case 'LOAD_INSURANCE_MODIFY_PRICE':
                return {...state ,insurance:{...state.insurance , price: action.data }}
            case 'LOAD_SUBSCRIPTION_MODIFY_PRICE':
                return {...state ,subscription:{...state.subscription , price: action.data.modify_amount}}
            case 'ADD_DRONE_SUBSCRIPTION':
                return {...state, subscription: {...state.subscription ,drones: [...state.subscription.drones, action.data]}}
            case 'ADD_DRONE_INSURANCE':
                return {...state, insurance: {...state.insurance ,insuranceChanged:true,drones: [...state.insurance.drones, action.data]}}
            case 'ADD_EQUIPMENT_SUBSCRIPTION':
                return {...state, subscription: {...state.subscription ,equipment: [...state.subscription.equipment ,action.data]}}
            case 'ADD_EQUIPMENT_INSURANCE':
                return {...state, insurance: {...state.insurance ,insuranceChanged:true,equipment: [...state.insurance.equipment ,action.data]}}
            case 'EDIT_DRONE_SUBSCRIPTION':
                return {...state, subscription : {...state.subscription , drones: state.subscription.drones.map((drone, index) => index === action.data.index ? action.data.drone : drone)}}
            case 'EDIT_DRONE_INSURANCE':
                return {...state, insurance : {...state.insurance ,insuranceChanged:true, drones: state.insurance.drones.map((drone, index) => index === action.data.index ? action.data.drone : drone)}}
            case 'EDIT_EQUIPMENT_SUBSCRIPTION':
                return {...state, subscription :{...state.subscription, equipment: state.subscription.equipment.map((equip, index) => index === action.data.index ? action.data.equipment : equip)}}
            case 'EDIT_EQUIPMENT_INSURANCE':
                return {...state, insurance :{...state.insurance,insuranceChanged:true, equipment: state.insurance.equipment.map((equip, index) => index === action.data.index ? action.data.equipment : equip)}}
            case 'DELETE_DRONE_SUBSCRIPTION':
                return {...state, subscription :{...state.subscription, drones: state.subscription.drones.filter((item, index) => index != action.data)}}
            case 'DELETE_DRONE_INSURANCE':
                return {...state, insurance :{...state.insurance,insuranceChanged:true, drones: state.insurance.drones.filter((item, index) => index != action.data)}}
            case 'DELETE_EQUIPMENT_SUBSCRIPTION':
                return {...state, subscription :{...state.subscription, equipment: state.subscription.equipment.filter((item, index) => index != action.data)}}
            case 'DELETE_EQUIPMENT_INSURANCE':
                return {...state, insurance :{...state.insurance,insuranceChanged:true, equipment: state.insurance.equipment.filter((item, index) => index != action.data)}}
            case 'EDIT_INSURED_SUBSCRIPTION':
                return {...state, subscription: { ...state.subscription, namedInsured: action.data }, isEditNamedInsured: false}
            case 'EDIT_INSURED_INSURANCE':
                return {...state, insurance: { ...state.insurance, namedInsured: action.data, insuranceChanged: true }, isEditNamedInsured: false}
            case 'EQUIPMENT_TYPES_LOADED':
                return {...state, equipmentTypes: [...action.data]}
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_PAYMENT_METHOD:
                return {...state, paymentMethod: action.data }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_EXTERNAL_USER_ID:
                return {...state, externalUserId: action.data }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_LIABILITY_VALID:
                return {...state, isLiabilityValid: action.data }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_NUMBER_OF_DRONES_VALID:
                return {...state, isNumberOfDronesValid: action.data }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_HULL_SECTION_VALID:
                return {...state, isHullSectionValid: action.data }
            case POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_ADDIONTAL_COVERAGE_VALID:
                return {...state, isAddionalCoverageValid: action.data }
            case 'EDIT_INSURED':
                return {...state, isEditNamedInsured: true }
          default: 
            return state;
        }
    }
     
    const newState = newStateCalculate()

    return newState
};


export const ModificationContextStore = React.createContext(defaultState)
ModificationContextStore.displayName = 'ModificationContext'

const ModificationContext = (props) => {
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const {user: {commercial}, setUserCommercial} = useContext(SessionContextStore)
    const insurance = props.insurance
    const insuranceId = props.insurance.insuranceId
    const isActive = () => {
        return insurance.getStatus() != InsuranceStatus.CANCELED && insurance.getStatus() != InsuranceStatus.EXPIRED
    }
    const loadLiabilityExtensionOffers = async (id) => {
        if(isActive()){
            let offers = await ModificationApi.loadLiabilityOptions(id)
            dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.LOAD_LIABILITY_OPTIONS, offers.data))
        }
    }
    const getPolicyDetails = async () => {
        const activeSubscription = insurance.subscription
            dispatch(new Action('SET_SUBSCRIPTION_DATA',
                {
                    commercial: commercial,
                    insuranceId: insurance.insuranceId,
                    drones: activeSubscription.drones,
                    equipment: activeSubscription.equipment,
                    medicalExpenseLimit: activeSubscription.medicalExpenseLimit,
                    numberOfDronesOperate: activeSubscription.numberOfDronesOperate,
                    liabilityLimit: activeSubscription.liabilityLimit,
                    billingPeriod: activeSubscription.billingPeriod,
                    nextPolicyDate: activeSubscription.nextBillingDate,
                    additionalInsuredList: policyManagementContext.allAdditionalInsuredList,
                    personalInjuryLimit: activeSubscription.personalInjuryLimit,
                    medicalExpenseLimitPremium: activeSubscription.medicalExpenseLimitPremium,
                    personalInjuryLimitPremium: activeSubscription.personalInjuryLimitPremium,
                    liabilityLimitPremium: activeSubscription.liabilityLimitPremium,
                    price: state.subscription.price,
                    namedInsured: activeSubscription.namedInsured
                }))
            dispatch(new Action('SET_INSURANCE_DATA',
                {
                    commercial: commercial,
                    insuranceChanged:false,
                    insuranceId: insurance.insuranceId,
                    drones: insurance.insuredDrones,
                    equipment: insurance.insuredEquipment,
                    medicalExpenseLimit: insurance.medicalExpenseLimit,
                    numberOfDronesOperate: insurance.numberOfDronesOperate,
                    liabilityLimit: insurance.liabilityLimit,
                    billingPeriod: activeSubscription.billingPeriod,
                    //nextPolicyDate: insurance.nextBillingDate,
                    additionalInsuredList: policyManagementContext.allAdditionalInsuredList,
                    personalInjuryLimit: insurance.personalInjuryLimit,
                    medicalExpenseLimitPremium: insurance.medicalExpenseLimitPremium,
                    personalInjuryLimitPremium: insurance.personalInjuryLimitPremium,
                    liabilityLimitPremium: insurance.liabilityLimitPremium,
                    stripeCustomerId: insurance.stripeCustomerId,
                    price: 0,
                    namedInsured: insurance.namedInsured
                }))
            await loadLiabilityExtensionOffers(insurance.insuranceId)
    }

    async function fetchData () {
        let types = await HullApi.getEquipmentTypes()
        dispatch(new Action('EQUIPMENT_TYPES_LOADED', types))
    }

    const [state, dispatch] = useReducer(reducer, defaultState, () => {
        let savedState = {}
        return Object.assign({}, defaultState)
    })

    const setCommercialInsurance = (flag) =>{
        dispatch({type: 'SET_COMMERCIAL_INSURANCE', data: flag})
    }

    const setCommercialSubscription = (flag) =>{
        dispatch({type: 'SET_COMMERCIAL_SUBSCRIPTION', data: flag})
    }

    const modify = async (isRenewal, withoutCC, approvedCommercial) => {
        let res; 
        let okPopupText;

        if(state.insurance.commercial || state.subscription.commercial){
            setUserCommercial()
        }
            if(isRenewal){
                state.subscription.equipment.map(x=>{
                    if(x.equipment_sub_type === undefined){
                        x.equipment_sub_type = state.equipmentTypes.find(y=>y.name === x.type).subType
                    }
                })
                res = await awaitWithLoading(ModificationApi.modify(insuranceId , {
                    number_of_drones_operate: state.subscription.numberOfDronesOperate,
                    personal_injury_limit: state.subscription.personalInjuryLimit,
                    liability_limit: state.subscription.liabilityLimit,
                    medical_expense_limit: state.subscription.medicalExpenseLimit,
                    is_commercial: state.insurance.commercial,
                    drones: state.subscription.drones.map(drone => {
                        return {
                        ...drone,
                        deductible_rate: drone.deductibleRate,
                        start_date: !!drone.startDate? drone.startDate: drone.start_date,
                        end_date: !!drone.endDate? drone.endDate: drone.end_date
                        }
                    }),
                    named_insured: state.subscription.namedInsured,
                    equipment: state.subscription.equipment.map(equipment => {
                        return {
                        ...equipment,
                        deductible_rate: equipment.deductibleRate
                        }
                    }),
                    approved_commercial: approvedCommercial
                }))
                okPopupText='Renewal has been updated '
            }
            else{
                state.insurance.equipment.map(x=>{
                    if(x.equipment_sub_type === undefined){
                        x.equipment_sub_type = state.equipmentTypes.find(y=>y.name === x.type).subType
                    }
                })
                res = await awaitWithLoading(ModificationApi.midterm(insuranceId , {
                    number_of_drones_operate: state.insurance.numberOfDronesOperate,
                    personal_injury_limit: state.insurance.personalInjuryLimit,
                    liability_limit: state.insurance.liabilityLimit,
                    medical_expense_limit: state.insurance.medicalExpenseLimit,
                    is_commercial: state.insurance.commercial,
                    drones: state.insurance.drones.map(drone => {
                        return {
                        ...drone,
                        deductible_rate: drone.deductibleRate,
                        start_date: !!drone.startDate? drone.startDate: drone.start_date,
                         end_date: !!drone.endDate? drone.endDate: drone.end_date
                        }
                    }),
                    named_insured: state.insurance.namedInsured,
                    equipment: state.insurance.equipment.map(equipment => {
                        return {
                        ...equipment,
                        deductible_rate: equipment.deductibleRate
                        }
                    }),
                    midterm_date:new Date(),
                    without_credit_Card: withoutCC,
                    approved_commercial: approvedCommercial
                }))
                okPopupText='Your policy has been updated'
            }
            if(res.ok){
                if(res.data !== 'No Changes'){
                    EventEmitterService.dispatch(EventKey.ShowSuccess, {
                    title: okPopupText,
                    body: 'Your changes have been made.',
                    onClose: () => {
                    window.location.reload(false)
                },})
                }
            
            }
            if(!res.ok)  {
                EventEmitterService.dispatch(EventKey.ShowError, res)
                return
            }
    }


    useEffect(() => {
        const validationList = [state.isAddionalCoverageValid, state.isHullSectionValid, state.isLiabilityValid, state.isNumberOfDronesValid]
        const isValid = !validationList.some(v => v === false)
        if(state.subscription != defaultSubscriptioInsurance && state.subscription.insuranceId != "" && isValid && state.equipmentTypes.length > 0)
        {
            calcSubscriptionPrices()
        }
    },[state.subscription.medicalExpenseLimit, state.subscription.personalInjuryLimit, state.subscription.liabilityLimit, state.subscription.drones, state.subscription.equipment, state.subscription.numberOfDronesOperate])
    
    useEffect(() => {
        const validationList = [state.isAddionalCoverageValid, state.isHullSectionValid, state.isLiabilityValid, state.isNumberOfDronesValid]
        const isValid = !validationList.some(v => v === false)
        if(state.insurance != defaultSubscriptioInsurance && state.insurance.insuranceId != "" && state.insurance.insuranceChanged && isValid)
        {
            calcMidtermPrices()
        }
    },[state.insurance.medicalExpenseLimit, state.insurance.personalInjuryLimit, state.insurance.liabilityLimit, state.insurance.drones, state.insurance.equipment, state.insurance.numberOfDronesOperate])

    useEffect(() => {
        fetchData()
        if(!!insurance && !!insuranceId)
            getPolicyDetails()

    }, [insurance])

   useEffect(() => {
    if(state.subscription != defaultSubscriptioInsurance && state.insurance != defaultSubscriptioInsurance && insuranceId != "" && !!insurance && state.equipmentTypes.length > 0)
    {
        calcSubscriptionPrices()
    }
   }, [insurance, state.equipmentTypes])

    const calcSubscriptionPrices = async () => {
        state.insurance.equipment.map(x=>{
                x.equipment_sub_type = state.equipmentTypes.find(y=>y.name === x.type).subType
        })
        ModificationApi.getModifyAmount(insuranceId , true, 
            {
            number_of_drones_operate: state.subscription.numberOfDronesOperate,
            personal_injury_limit: state.subscription.personalInjuryLimit,
            liability_limit: state.subscription.liabilityLimit,
            medical_expense_limit: state.subscription.medicalExpenseLimit,
            drones: state.subscription.drones,
            equipment: state.subscription.equipment
            }).then((res) => {
                dispatch(new Action('LOAD_SUBSCRIPTION_MODIFY_PRICE', res.data))
            })
    }
    const calcMidtermPrices = async () =>{
            state.insurance.equipment.map(x=>{
                x.equipment_sub_type = state.equipmentTypes.find(y=>y.name === x.type).subType
            })
            const drones= state.insurance.drones.map(x=>{ 
                return {...x, start_date: !!x.startDate? x.startDate: x.start_date , end_date: !!x.endDate? x.endDate: x.end_date}})
            ModificationApi.getMidtermAmount(insuranceId , true, {
            number_of_drones_operate: state.insurance.numberOfDronesOperate,
            personal_injury_limit: state.insurance.personalInjuryLimit,
            liability_limit: state.insurance.liabilityLimit,
            medical_expense_limit: state.insurance.medicalExpenseLimit,
            drones: drones,
            equipment: state.insurance.equipment,
            midterm_date: new Date()
            }).then((res) => {
                dispatch(new Action('LOAD_INSURANCE_MODIFY_PRICE', res.data.total))
            })
    }




    // Drones, Equipment Loads and Updates
    useEffect(() => {
        let id3 = EventEmitterService.subscribe(EventKey.USER_LOGGED_IN, async () => {
            if (state && state.drones && state.drones.length > 0) 
                await HullApi.saveDrones(state.drones)
            if (state && state.equipment && state.equipment.length > 0) 
                await HullApi.saveEquipment(state.equipment)

        })

        if(state != defaultState)
            EventEmitterService.dispatch(EventKey.HULL_ITEM_CHANGED, {drones: state.drones, equipment: state.equipment})

        return function cleanup() {
            EventEmitterService.unsubscribe(EventKey.USER_LOGGED_IN, id3)
        }
    }, [state.drones, state.equipment])

    const setMedicalExpenseLimit = (option, isRenewal) => {
        if(isRenewal)
            dispatch(new Action('CHANGE_MEDICAL_EXPENSE_LIMIT_SUBSCRIPTION', option))
        else
            dispatch(new Action('CHANGE_MEDICAL_EXPENSE_LIMIT_INSURANCE', option))
    }

    const setNumberOfDronesOperate = (option, isRenewal) => {
        if(isRenewal)
            dispatch(new Action('CHANGE_NUMBER_OF_DRONES_OPERATE_SUBSCRIPTION', option))
        else
            dispatch(new Action('CHANGE_NUMBER_OF_DRONES_OPERATE_INSURANCE', option))
    }

    const setLiabilityLimit = (option,isRenewal) => {
        if(isRenewal)
            dispatch(new Action('CHANGE_LIABILIY_LIMIT_SUBSCRIPTION', option))
        else
            dispatch(new Action('CHANGE_LIABILIY_LIMIT_INSURANCE', option))
    }

    const setPersonalInjuryLimit = (option, isRenewal) => {
        if(isRenewal)
            dispatch(new Action('CHANGE_PERSONAL_INJURY_LIMIT_SUBSCRIPTION', option))
        else
            dispatch(new Action('CHANGE_PERSONAL_INJURY_LIMIT_INSURANCE', option))
    }


    
    const addDrone = async (drone,index , isRenewal) => {
        drone.value = parseFloat(drone.value)
        if(isRenewal)
            dispatch(new Action('ADD_DRONE_SUBSCRIPTION', drone))
        else 
            dispatch(new Action('ADD_DRONE_INSURANCE', drone))
    }

    const editDrone = async (drone, index,isRenewal) => {
        drone.value = parseFloat(drone.value)
        if(isRenewal)
            dispatch(new Action('EDIT_DRONE_SUBSCRIPTION', {drone: drone, index: index}))
        else 
            dispatch(new Action('EDIT_DRONE_INSURANCE', {drone: drone, index: index}))
    }

    const saveInsured = (profile, isRenewal) => {
        if(isRenewal)
            dispatch(new Action('EDIT_INSURED_SUBSCRIPTION', profile))
        else 
            dispatch(new Action('EDIT_INSURED_INSURANCE', profile))
    }

    const editInsured = () => {
        dispatch(new Action('EDIT_INSURED'))
    }

    const addEquipment = async (equipment,index, isRenewal) => {
        equipment.quantity = parseFloat(equipment.quantity)
        equipment.value = parseFloat(equipment.value)
        if(isRenewal)
            dispatch(new Action('ADD_EQUIPMENT_SUBSCRIPTION', equipment))
        else 
            dispatch(new Action('ADD_EQUIPMENT_INSURANCE', equipment))
    }

    const editEquipment = async (equipment, index,isRenewal) => {
        equipment.quantity = parseFloat(equipment.quantity)
        equipment.value = parseFloat(equipment.value)
        if(isRenewal)
            dispatch(new Action('EDIT_EQUIPMENT_SUBSCRIPTION', {equipment: equipment, index: index}))
        else 
            dispatch(new Action('EDIT_EQUIPMENT_INSURANCE', {equipment: equipment, index: index}))
    }

    const deleteItem = async (index, item,isRenewal) => {
        if(item == 'drone') {
            if(isRenewal)
                dispatch(new Action('DELETE_DRONE_SUBSCRIPTION', index))
            else 
                dispatch(new Action('DELETE_DRONE_INSURANCE', index))
        }
        else {
            if(isRenewal)
                dispatch(new Action('DELETE_EQUIPMENT_SUBSCRIPTION', index))
            else 
                dispatch(new Action('DELETE_EQUIPMENT_INSURANCE', index))
        }        
    }

    return (<ModificationContextStore.Provider value={{ ...state, setCommercialSubscription, setCommercialInsurance, editInsured, saveInsured, dispatch,getPolicyDetails,modify,setNumberOfDronesOperate,setLiabilityLimit,setMedicalExpenseLimit, setPersonalInjuryLimit,
      addDrone, addEquipment,
      deleteItem, editInsuredEquipment: editEquipment, editEquipment, editDrone, editInsuredDrone: editDrone}}>
            {props.children}
        </ModificationContextStore.Provider>)   
}

export default ModificationContext



